import type { ReactNode } from 'react';

/**
 * Renders only its children — the markdown element that "disappears" from
 * the tree. Building block for `INLINE_MARKDOWN_COMPONENTS`; not meant to be
 * rendered directly.
 */
export const InlineText = ({ children }: { children?: ReactNode }): ReactNode =>
  children;
